import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupText,
  Row,
  Col,
  Alert,
} from 'reactstrap';
import Draggable from 'react-draggable';

import { FetchData, FetchFile, UploadFile } from './utils/DataFetch';
import { GetCookie, Timeout } from './utils/Common';
import { TroubleTicketActionItemForm } from './TroubleTicketActionItemForm';
import { TroubleTicketActionItemTableDefault } from './TroubleTicketActionItemTableDefault';

import { saveAs } from 'file-saver';

const moment = require('moment');

export class TroubleTicketActionForm extends Component {
  static displayName = TroubleTicketActionForm.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie('user'));
    this.state = {
      model: props.model,
      alert: props.alert || { color: '', message: '', isOpen: false },
      deltaPosition: { x: 0, y: 0 },
      actionItemList: [],
      modalItemForm: false,
      itemFormModel: null,
    };

    this.onSave = this.onSave.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.keydownHandler = this.keydownHandler.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.keydownHandler);
    if (this.state.model.TroubleTicketActionId) {
      this.populateActionItems();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keydownHandler);
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag = (e, ui) => {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  };

  keydownHandler(e) {
    if (e.keyCode === 83 && e.altKey) {
      if (this.state.modalItemForm || e.defaultPrevented) return;
      e.preventDefault();
      this.onSave();
    }
  }

  handleChange(e) {
    let model = { ...this.state.model };
    if (e.target.type === 'checkbox') model[e.target.name] = e.target.checked;
    else model[e.target.name] = e.target.value;
    this.setState({ model });
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
      }
    );
  }

  onSave() {
    let model = { ...this.state.model };

    if (model.EventType === 'insert') {
      model.CreateByUserId = this.user.userid;
    } else if (model.EventType === 'update') {
      model.UpdateByUserId = this.user.userid;
    }

    FetchData(
      '/savetroubleticketaction',
      'POST',
      this.user.token,
      model
    ).then((data) => {
      if (data === 'Success' && model.EventType === 'insert') {
        this.setState({
          model: { ...this.state.model, EventType: 'update' },
        });
      }
      this.props.onActionSaved({
        message: data,
        color: data === 'Success' ? 'success' : 'warning',
      });
    });
  }

  onDelete() {
    let model = { ...this.state.model };
    model.EventType = 'delete';
    model.IsDeletedFlg = true;
    model.UpdateByUserId = this.user.userid;

    FetchData(
      '/savetroubleticketaction',
      'POST',
      this.user.token,
      model
    ).then((data) => {
      this.props.onActionSaved({
        message: data,
        color: data === 'Success' ? 'success' : 'warning',
        closeModal: data === 'Success',
      });
    });
  }

  populateActionItems() {
    FetchData('/gettroubleticketactionitems', 'POST', this.user.token, {
      TroubleTicketActionId: this.state.model.TroubleTicketActionId,
    }).then((data) => {
      if (Array.isArray(data)) {
        this.setState({ actionItemList: data });
      }
    });
  }

  resetItemFields() {
    this.setState({
      modalItemForm: true,
      itemFormModel: {
        EventType: 'insert',
        TroubleTicketActionItemId: null,
        TroubleTicketActionId: this.state.model.TroubleTicketActionId,
        TroubleTicketActionItemDescription: '',
        FileLocationS3: '',
        FileName: '',
        FormFile: null,
        CreateByUserId: null,
        UpdateByUserId: null,
      },
    });
  }

  handleItemDoubleClick(item) {
    this.setState({
      modalItemForm: true,
      itemFormModel: {
        EventType: 'update',
        TroubleTicketActionItemId: item.troubleTicketActionItemId,
        TroubleTicketActionId: item.troubleTicketActionId,
        TroubleTicketActionItemDescription:
          item.troubleTicketActionItemDescription,
        FileLocationS3: item.fileLocationS3,
        FileName: item.fileName,
        FormFile: null,
        CreateByUserId: item.createByUserId,
        UpdateByUserId: null,
      },
    });
  }

  handleItemSaveSuccess(alert) {
    this.setState({ modalItemForm: false, itemFormModel: null });
    this.populateActionItems();
    this.handleSaveEventSuccess(alert);
  }

  handleItemDelete(item) {
    if (!window.confirm('Are you sure you want to delete this attachment?')) return;

    const formData = new FormData();
    formData.append('EventType', 'delete');
    formData.append('TroubleTicketActionItemId', item.troubleTicketActionItemId || '');
    formData.append('UpdateByUserId', this.user.userid || '');

    UploadFile('/savetroubleticketactionitem', this.user.token, formData).then((data) => {
      const rawMessage = data && typeof data === 'object' && data.message ? data.message : data;
      const message = String(rawMessage || '').trim().replace(/^"+|"+$/g, '');
      const isSuccess = /\bsuccess\b/i.test(message);
      this.populateActionItems();
      this.handleSaveEventSuccess({ message, color: isSuccess ? 'success' : 'warning' });
    });
  }

  async downloadFile(item) {
    const payload = {
      TroubleTicketActionItemId: item.troubleTicketActionItemId,
      FileLocationS3: item.fileLocationS3,
      FileName: item.fileName,
    };

    await FetchFile(
      '/gettroubleticketactionitemfile',
      'POST',
      this.user.token,
      payload
    ).then((blob) => {
      saveAs(blob, item.fileName);
    });
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition } = this.state;
    const m = this.state.model;

    return (
      <Draggable handle=".handle" onDrag={this.handleDrag} {...dragHandlers}>
        <div>
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.setModal}
            style={{
              transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
              width: '700px',
              maxWidth: '700px',
            }}
            backdrop="static"
          >
            <ModalHeader className="handle">
              {m.EventType === 'insert' ? 'New Action' : 'Edit Action'}
            </ModalHeader>
            <ModalBody>
              <div>
                <Row>
                  <Col>
                    <Alert
                      color={this.state.alert.color}
                      isOpen={this.state.alert.isOpen}
                      style={{ textAlign: 'center' }}
                    >
                      {this.state.alert.message}
                    </Alert>
                  </Col>
                </Row>

                <Row>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '110px' }}>
                        Date:
                      </InputGroupText>
                      <input
                        type="datetime-local"
                        name="ActionDateTime"
                        className="form-control form-control-text"
                        value={
                          m.ActionDateTime
                            ? moment(m.ActionDateTime).format(
                                'YYYY-MM-DDTHH:mm'
                              )
                            : ''
                        }
                        onChange={(e) => {
                          let model = { ...this.state.model };
                          model.ActionDateTime = e.target.value || null;
                          this.setState({ model });
                        }}
                      />
                    </InputGroup>
                  </Col>
                  <Col className="col-6">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '110px' }}>
                        Status:
                      </InputGroupText>
                      <select
                        name="ActionStatus"
                        className="form-control form-control-text"
                        value={m.ActionStatus || ''}
                        onChange={this.handleChange}
                      >
                        <option value=""></option>
                        <option value="Open">Open</option>
                        <option value="In Progress">In Progress</option>
                        <option value="Completed">Completed</option>
                        <option value="Cancelled">Cancelled</option>
                      </select>
                    </InputGroup>
                  </Col>
                </Row>

                <Row>
                  <Col className="col-12">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '110px' }}>
                        Description:
                      </InputGroupText>
                      <textarea
                        name="ActionDescription"
                        rows="4"
                        className="form-control form-control-text"
                        value={m.ActionDescription || ''}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                </Row>

                <Row>
                  <Col className="col-12">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '110px' }}>
                        Next Steps:
                      </InputGroupText>
                      <textarea
                        name="NextSteps"
                        rows="3"
                        className="form-control form-control-text"
                        value={m.NextSteps || ''}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </Col>
                </Row>

                {/* Attachments section */}
                {m.EventType !== 'insert' && (
                  <div style={{ marginTop: '8px' }}>
                    <hr />
                    <Button
                      className="btn-secondary-no-background form-control-text"
                      size="sm"
                      onClick={() => this.resetItemFields()}
                    >
                      New Attachment
                    </Button>
                    {this.state.actionItemList.length > 0 && (
                      <div style={{ marginTop: '4px' }}>
                        <TroubleTicketActionItemTableDefault
                          actionItemList={this.state.actionItemList}
                          onEdit={(item) => this.handleItemDoubleClick(item)}
                          onDelete={(item) => this.handleItemDelete(item)}
                          onDownload={(item) => this.downloadFile(item)}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </ModalBody>
            <ModalFooter />
          </Modal>

          {this.state.modalItemForm && this.state.itemFormModel && (
            <TroubleTicketActionItemForm
              model={this.state.itemFormModel}
              modal={this.state.modalItemForm}
              alert={{ color: '', message: '', isOpen: false }}
              setModal={() =>
                this.setState({ modalItemForm: false, itemFormModel: null })
              }
              handleSaveEventSuccess={(alert) =>
                this.handleItemSaveSuccess(alert)
              }
            />
          )}
        </div>
      </Draggable>
    );
  }
}
